<template>
  <Countdown :seconds="seconds" @finish="countdownFinished" @start="start" />
  <div v-if="!started">GOAL: <input type="number" v-model="goal" /></div>
  <div v-if="started">Correct: {{ achieved }}; goal: {{ goal }}</div>
  <!-- <div>Score: {{ score }}</div> -->
  <div id="container">
    <div id="top">
      <div class="text">meaning</div>
      <div class="flex">
        <div class="big">
          <div>
            <span>{{ currentName[0] }}</span>
          </div>
        </div>
      </div>
    </div>
    <div id="bottom">
      <div class="text">text color</div>
      <div class="flex">
        <div class="big">
          <span :style="{ color: currentFarbe }">{{ currentName[1] }}</span>
        </div>
      </div>
    </div>
    <div id="low">
      <div class="flex">
        <div class="center">
          <img class="arrow rotate" src="@/assets/arrow.svg" alt="" /> wrong
        </div>
        <div class="center">
          <img class="arrow" src="@/assets/arrow.svg" alt="" /> correct
        </div>
      </div>
    </div>

    <img
      v-if="correct"
      class="correct"
      src="@/assets/check.svg"
      alt="correct"
    />
    <img v-if="wrong" class="wrong" src="@/assets/x.svg" alt="wrong" />
  </div>
</template>

<script>
import Countdown from "./Countdown.vue";

const names = ["red", "green", "blue", "yellow"];
const farben = ["red", "lime", "blue", "#fff200"];

export default {
  name: "Color",
  components: {
    Countdown,
  },
  data() {
    return {
      started: false,
      currentName: ["", ""],
      currentFarbe: "",

      farbIndex: -1,
      nameIndex: -1,

      score: 0,
      finish: false,
      seconds: 45,
      correct: false,
      wrong: false,
      solvedTimer: {},
      goal: 30,
      achieved: 0,
    };
  },
  methods: {
    initTimer(which) {
      clearTimeout(this.solvedTimer);

      if (which === "correct") {
        this.correct = true;
        this.wrong = false;
      } else {
        this.correct = false;
        this.wrong = true;
      }

      this.solvedTimer = setTimeout(() => {
        this.correct = false;
        this.wrong = false;
      }, 1000);
    },
    countdownFinished() {
      this.finish = true;
      console.log("countdownFinished");
    },
    updateScore(n) {
      if (n > 0) this.achieved++;
      if (n < 0) this.achieved--;
      this.score += n;
    },
    start() {
      this.started = true;
      this.init();
    },
    init() {
      this.reset();
      this.initKeyboard();
      this.generateNewCombination();
    },
    // won() {
    //   console.log("win");
    //   //win animation TODO
    // },
    // loose() {
    //   console.log("win");
    //   this.reload();
    // },
    reset() {
      //reset variables
      this.currentName = ["", ""];
      this.currentFarbe = "";
      this.farbIndex = -1;
      this.nameIndex = -1;
      this.score = 0;
      this.achieved = 0;
      this.finish = false;
    },
    getRandomName() {
      return Math.floor(Math.random() * names.length);
    },
    getRandomFarbe() {
      return Math.floor(Math.random() * farben.length);
    },
    checkAnswer(answer) {
      if (this.nameIndex === this.farbIndex && answer === "correct")
        return true;
      if (this.nameIndex != this.farbIndex && answer === "wrong") return true;
      return false;
    },
    generateNewCombination() {
      //mehr richtige
      if (Math.floor(Math.random() * 2) % 2 === 0) {
        //make em richtig
        this.nameIndex = this.getRandomName();
        this.currentName[0] = names[this.nameIndex];
        this.currentName[1] = names[this.getRandomName()];

        this.farbIndex = this.nameIndex;
        this.currentFarbe = farben[this.farbIndex];
        return;
      } else {
        //make em falsch

        this.nameIndex = this.getRandomName();
        this.currentName[0] = names[this.nameIndex];
        this.currentName[1] = names[this.getRandomName()];

        this.farbIndex = this.getRandomFarbe();

        //if the same do again
        if (this.nameIndex === this.farbIndex)
          this.farbIndex = this.getRandomFarbe();
        if (this.nameIndex === this.farbIndex)
          this.farbIndex = this.getRandomFarbe();
        //wenns immer noch gleich ist, dann egal

        this.currentFarbe = farben[this.farbIndex];
      }
    },
    keyBoardPress(answer) {
      if (this.checkAnswer(answer)) {
        this.updateScore(10);
        this.initTimer("correct");
      } else {
        this.updateScore(-10);
        this.initTimer("wrong");
      }
      this.generateNewCombination();
    },
    initKeyboard() {
      window.addEventListener("keydown", (event) => {
        if (this.finish) return;
        event.preventDefault();
        if (this.keyPressed) return;
        this.keyPressed = true;
        console.log(event.code);
        if (event.code === "ArrowLeft") {
          this.keyBoardPress("wrong");
        }
        if (event.code === "ArrowRight") {
          this.keyBoardPress("correct");
        }
      });

      window.addEventListener("keyup", () => {
        this.keyPressed = false;
      });
    },
  },
  created() {},
};
</script>

<style scoped>
.red {
  color: red;
}

.correct,
.wrong {
  position: absolute;
  width: 100px;
  left: 50%;
  top: 44%;
  transform: translate(-50%, -50%);
}
.flex {
  display: flex;
  height: 60%;
  width: 100%;
  justify-content: space-around;
}

.text {
  margin: 20px;
}

.center {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.arrow {
  width: 80px;
}

.rotate {
  transform: rotate(180deg);
}

.big {
  font-size: 100px;
  width: 80%;
  height: 100%;
  border: 1px solid;
  display: flex;
  align-items: center;
  justify-content: space-around;
  color: black;
  font-weight: 600;
}

#container {
  width: 500px;
  height: 500px;
  border: 2px solid;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  position: relative;
}

#top,
#bottom {
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
}
</style>
